/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetRef } from './assetRef';
import { CompanyRef } from './companyRef';
import { TeamUser } from './teamUser';


export interface Team { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    name: string;
    status: Team.StatusEnum;
    agency: CompanyRef;
    users?: Array<TeamUser>;
    assets?: Array<AssetRef>;
}
export namespace Team {
    export type StatusEnum = 'active' | 'inactive';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


